import {analytics, logAnalyticsEvent} from './firebase';

interface LogEventData {
	eventName: string;
	routeName?: string;
	beneficiary?: {
		nuCpfC: string;
		nmUsuarioC: string;
		nmSocialUsuarioC: string | null;
		tipoUsuarioC: string;
		dtAdesaoC: string;
		dtCarenciaC: string;
		dtCarenciaOdontoC: string;
		nuContratoC: string;
		nuRegistroPlano: string;
		tipoPlanoC: string;
		tipoContratacao: string;
	};
	operator?: number[];
}

const logEvent = ({eventName, routeName, beneficiary, operator}: LogEventData) => {
	logAnalyticsEvent(analytics, eventName, {
		route_name: routeName,
		nm_cpf_c: beneficiary?.nuCpfC,
		nm_usuario_c: beneficiary?.nmUsuarioC,
		nm_social_usuario_c: beneficiary?.nmSocialUsuarioC,
		tipo_usuario_c: beneficiary?.tipoUsuarioC,
		dt_adesao_c: beneficiary?.dtAdesaoC,
		dt_carencia_c: beneficiary?.dtCarenciaC,
		dt_carencia_odonto_c: beneficiary?.dtCarenciaOdontoC,
		nm_contrato_c: beneficiary?.nuContratoC,
		nu_registro_plano: beneficiary?.nuRegistroPlano,
		tipo_plano_c: beneficiary?.tipoPlanoC,
		tipo_contratacao: beneficiary?.tipoContratacao,
		nu_operadora: operator,
	});
};

const logEventBooking = ({eventName}: LogEventData) => {
	logAnalyticsEvent(analytics, eventName);
};

export {logEventBooking, logEvent};
